import React from 'react';

import { Add } from './Add';
import { AddTranslation } from './AddTranslation';
import { Edit } from './Edit';
import { List } from './List';

export const investmentPassportsRoutes = {
  path: '/investmentPassports',
  children: [
    {
      path: '',
      element: <List />,
    },
    {
      path: 'add',
      element: <Add />,
    },
    {
      path: ':id/add-translation',
      element: <AddTranslation />,
    },
    {
      path: ':id/edit',
      element: <Edit />,
    },
  ],
};
